import {Loader, MultiSelect, MultiSelectProps} from "@mantine/core";

export type BaseMultiSelectProps = Omit<MultiSelectProps, "rightSection"> & {
    loading?: boolean;
};

export function BaseMultiSelect(props: BaseMultiSelectProps) {
    const {loading, ...rest} = props;

    return (
        <MultiSelect
            rightSection={loading ? <Loader size="sm"/> : undefined}
            {...rest} />
    );
}
